import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { useUpgradePlanContext } from "./../UpgradePlanContext";
import { PlanLineItems } from "./PlanLineItems";
import { getDisplayName, getDisplaySubheading } from "./helpers";

const i18nRoot = "pricing_plans.upgrade_modal";

interface UpgradeIntervalDetailsProps {
  hideModal: () => void;
  onSubmitHandler: () => void;
  subheading?: string;
}

export const UpgradeIntervalDetails = ({
  subheading = "",
  hideModal,
  onSubmitHandler,
}: UpgradeIntervalDetailsProps) => {
  const { plan, emailHubPlan, isEmailHubOnlyUpgrade } = useUpgradePlanContext();

  const displayName = getDisplayName(plan, emailHubPlan);

  const displaySubheading = getDisplaySubheading(
    subheading,
    isEmailHubOnlyUpgrade,
  );

  return (
    <>
      <Modal.Header>
        <Modal.Title>
          {t([i18nRoot, "interval_upgrade_title"], {
            plan: displayName,
          })}
        </Modal.Title>

        <Modal.HeaderActions>
          <Modal.CloseButton onClick={hideModal} />
        </Modal.HeaderActions>
      </Modal.Header>
      <Modal.Body>
        {displaySubheading && (
          <div className="mb-6">
            <Typography.BodyMd color="text-default">
              {displaySubheading}
            </Typography.BodyMd>
          </div>
        )}

        <div className="mb-6">
          <Typography.LabelMd weight="semibold" size="text-base">
            {t([i18nRoot, "interval_switch.upgrade.cta"])}
            <span className="text-green-success">
              {t(`${i18nRoot}.interval_switch.upgrade.savings`, {
                savings: plan?.annual_discount_amount_with_currency,
              })}
            </span>
          </Typography.LabelMd>

          <Typography.BodySm weight="normal" size="text-sm">
            {t([i18nRoot, "interval_switch.upgrade.cta_subheading"])}
          </Typography.BodySm>
        </div>

        <PlanLineItems />
      </Modal.Body>
      <Modal.Footer className="mt-5 flex justify-end">
        <Button variant="circle" large onClick={onSubmitHandler}>
          {t([i18nRoot, "actions.interval_upgrade"], { plan: displayName })}
        </Button>
      </Modal.Footer>
    </>
  );
};
